import { style } from "@vanilla-extract/css";
import { cellStyles } from "plos/src/components/Table/tables.css";
import { breakpoints, vars } from "plos/src/styles";

export const statusTwoCol = style({
  display: "grid",
  gridTemplateColumns: "minmax(0,1fr)",
  alignItems: "start",
  gap: vars.space.m,
  "@media": {
    [`screen and (min-width: ${breakpoints[4]})`]: {
      gridTemplateColumns: "minmax(0,1fr) minmax(0,1fr)",
    },
  },
});

export const dateCol = style({
  width: "50%",
  textAlign: "start",
});

export const dateCell = style({
  fontFamily: vars.fonts.bold,
});

export const pointsStatusCol = style({
  width: "50%",
  textAlign: "center",
});

export const pointsStatusCell = style([
  cellStyles,
  {
    textTransform: "uppercase",
  },
]);

export const pointsStatusIndicator = style({
  borderRadius: vars.radii.xs,
  backgroundColor: vars.colors.surfaceFixed,
  padding: vars.space["2xs"],
  textAlign: "center",
  color: vars.colors.onSurfaceFixed,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.xs,
  "@media": {
    [`screen and (min-width: ${breakpoints[5]})`]: {
      fontSize: vars.fontSizes.body.s,
    },
  },
});

export const pointsStatusIndicatorStarted = style({
  backgroundColor: "#04FC6F",
});

export const pointsStatusIndicatorProvisional = style({
  backgroundColor: vars.colors.copnr[50].backgroundColor,
  color: vars.colors.copnr[50].color,
});
